module.exports = __webpack_public_path__ + "static/bg-welcome-223921473b7c63a9219468df22db35c2.jpg";